const lookup = {
  'ai03/equinox': {
    target: 'ai03/equinox/rev1'
  },
  alice: {
    target: 'tgr/alice'
  },
  angel17: {
    target: 'angel17/alpha'
  },
  angel64: {
    target: 'angel64/alpha'
  },
  'atom47/rev2': {
    target: 'maartenwut/atom47/rev2'
  },
  'atom47/rev3': {
    target: 'maartenwut/atom47/rev3'
  },
  'bpiphany/pegasushoof': {
    target: 'bpiphany/pegasushoof/2013'
  },
  canoe: {
    target: 'percent/canoe'
  },
  'doro67/multi': {
    layouts: {
      LAYOUT_ansi: 'LAYOUT_65_ansi_blocker'
    }
  },
  'doro67/regular': {
    layouts: {
      LAYOUT: 'LAYOUT_65_ansi_blocker'
    }
  },
  'doro67/rgb': {
    layouts: {
      LAYOUT: 'LAYOUT_65_ansi_blocker'
    }
  },
  'dztech/dz60rgb': {
    target: 'dztech/dz60rgb/v1'
  },
  'dztech/dz60rgb_ansi': {
    target: 'dztech/dz60rgb_ansi/v1'
  },
  'dztech/dz60rgb_wkl': {
    target: 'dztech/dz60rgb_wkl/v1'
  },
  'dztech/dz65rgb': {
    target: 'dztech/dz65rgb/v1'
  },
  gh60: {
    target: 'gh60/revc'
  },
  idb_60: {
    target: 'idb/idb_60',
    layouts: {
      LAYOUT: 'LAYOUT_all'
    }
  },
  'kbdfans/kbd67mkiirgb': {
    target: 'kbdfans/kbd67/mkiirgb',
    layouts: {
      LAYOUT: 'LAYOUT_65_ansi_blocker'
    }
  },
  'kbdfans/kbd67/mkiirgb': {
    target: 'kbdfans/kbd67/mkiirgb/v1'
  },
  kudox: {
    target: 'kudox/rev1'
  },
  'lfkeyboards/lfk78': {
    target: 'lfkeyboards/lfk78/revj'
  },
  'mechlovin/hannah910': {
    target: 'mechlovin/hannah910/rev1'
  },
  'noxary/268_2': {
    layouts: {
      LAYOUT: 'LAYOUT_65_ansi_blocker'
    }
  },
  'percent/canoe': {
    layouts: {
      LAYOUT_iso: 'LAYOUT_65_iso_blocker'
    }
  },
  plain60: {
    target: 'maartenwut/plain60'
  },
  'primekb/prime_l': {
    target: 'primekb/prime_l/v1'
  },
  'primekb/prime_l_v2': {
    target: 'primekb/prime_l/v2'
  },
  'rama/koyu': {
    target: 'wilba_tech/rama_works_koyu'
  },
  'rama/m6_a': {
    target: 'wilba_tech/rama_works_m6_a'
  },
  'rama/m6_b': {
    target: 'wilba_tech/rama_works_m6_b'
  },
  'rama/m10_b': {
    target: 'wilba_tech/rama_works_m10_b'
  },
  'rama/m60_a': {
    target: 'wilba_tech/rama_works_m60_a'
  },
  'rama/u80_a': {
    target: 'wilba_tech/rama_works_u80_a'
  },
  romac: {
    target: 'kingly_keys/romac'
  },
  ropro: {
    target: 'kingly_keys/ropro'
  },
  satan: {
    target: 'gh60/satan'
  },
  skog: {
    target: 'percent/skog'
  },
  suihankey: {
    target: 'suihankey/split/alpha'
  },
  ta65: {
    target: 'maartenwut/ta65'
  },
  vinta: {
    layouts: {
      LAYOUT_67_ansi: 'LAYOUT_65_ansi_blocker'
    }
  },
  wasdat: {
    target: 'maartenwut/wasdat'
  },
  'westfoxtrot/cypher': {
    target: 'westfoxtrot/cypher/rev1'
  },
  zeal60: {
    target: 'wilba_tech/zeal60'
  },
  zeal65: {
    target: 'wilba_tech/zeal65'
  }
};

export default { lookup };
